import { Alert } from '@mui/material'
import Testo from './Testo'

export default function MessaggioEvidenziato(props) {
  const {
    info,
    success,
    warning,
    error,
    titolo,
    children,
    ...restProps
  } = props

  let severity = ''
  if (info) severity = 'info'
  if (success) severity = 'success'
  if (warning) severity = 'warning'
  if (error) severity = 'error'

  return (
    <Alert
      // variant='outlined'
      severity={severity}
      {...restProps}
    >
      {titolo && <Testo grassetto>{titolo}</Testo>}
      {children}
    </Alert>
  )
}